<template>
    <div>
        <div ref="chart" :style="{width: '100%', height: '600px'}"></div>
    </div>
</template>

<script>
    import echart from 'echarts'
    import Moment from "moment";

    export default {
        name: "echart",
        props: {
            scheduleList: Array,
            show: Boolean,
            bigCategoryDtos: Array,
            scoreDataDtos: Array,
            scoreDataDtosup: Array,
            isSel: {type: String, default: null}
        },
        computed: {
            option() {
                let option = {
                    title: {
                        show: false,
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: {
                                name: 'score',
                                show: true,
                                title: " "
                            }
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    legend: {
                        data: [],
                        bottom: 0
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '5%',
                        top: "30",
                        containLabel: true
                    },
                    yAxis: [
                        {
                            type: 'value'
                        }
                    ],
                    xAxis: [
                        {
                            type: 'category',
                            data: [],
                        }, {
                            type: 'category',
                            data: [],
                            position: 'bottom', //坐标轴的位置，位于底部
                            axisLabel: {
                                margin: 30 //文字与坐标轴的间隔
                            },
                        }
                    ],
                    series: []
                };
                this.scheduleList.forEach(schedule => {
                    if (this.isSel == 'Y') {
                        option.xAxis[0].data.push('供应商自评分');
                    }
                        option.xAxis[0].data.push('SS评分');
                    option.xAxis[1].data.push(schedule.supplierName);
                })

                function sum(arr) {
                    return eval(arr.join("+"));
                };
                for (const item of this.bigCategoryDtos) {
                    option.legend.data.push(item.bigName)
                }
                //将得到的所有子列分数，转换成列的形式，以供应商列为分组
                //拿到每个子列的分数，判断填写的分数之和是否超过大类总数
                for (const big of this.bigCategoryDtos) {
                    let ss = []
                    for (let i = 0; i < this.scoreDataDtos.length; i++) {
                        if (this.isSel == 'Y') {
                            let c = []
                            for (const small of big.smallItemDtos) {
                                if (this.scoreDataDtosup[i].scores[small.aa]) {
                                    c.push(this.scoreDataDtosup[i].scores[small.aa])
                                } else {
                                    c.push(0)
                                }
                            }
                            ss.push(sum(c))
                        }
                        let s = []
                        for (const small of big.smallItemDtos) {
                            if (this.scoreDataDtos[i].scores[small.aa]) {
                                s.push(this.scoreDataDtos[i].scores[small.aa])
                            } else {
                                s.push(0)
                            }
                        }
                        ss.push(sum(s))
                    }
                    option.series.push({name: big.bigName, type: 'bar', stack: '广告', data: ss})
                }
                return option;
            }
        },
        data: () => {
            return {
                chart: null
            }
        },
        mounted() {
            this.chart = echart.init(this.$refs.chart);
            this.chart.setOption(this.option);
        },
        watch: {
            show(value) {
                if (value) {
                    this.chart.setOption(this.option);
                }
            }
        }
    }
</script>

<style scoped>

</style>
